import { IChecklistDependency } from './checklist-dependency';
import { Translatable } from 'src/packages/mitsBasics';
import { ChecklistModuleType } from '../types';

export interface IChecklistModule extends Translatable<IChecklistModule> {
  /** Type of this module */
  type: ChecklistModuleType;
  /** Dependencies attached to this module */
  dep: IChecklistDependency[];
  /** ID of the dependency this module belongs to */
  dependency_id: number;
  /** ID of the gorup this module belongs to */
  group_id: number;
  /** Value of this module */
  value: string;

  /** Default Value for Field */
  default_value: string;

  /**
   * - Description for the GalleryModule
   * - Options for the SelectModule
   */
  description: string;
  /** Placeholder to show inside module/field */
  placeholder: string;
  /** Title or Name of this module/field */
  title: string;
  /** Index of sorting */
  sort_index: number;
  /** Deletes this module in backend */
  _destroy: boolean;

  /** Ids für die Verknüpfung von Modulen und temporären Bildern */
  temporary_image_remote_ids: string[];
  /**
   * Rein clientseitiger, eindeutiger Schlüssel zur Zuordnung der temporären
   * Galerie-Bilder zu genau diesem Modul. Wird benötigt, weil `id` beim
   * Instanziieren einer Checkliste entfernt wird und sonst alle Galerie-Bilder
   * unter `undefined` kollidieren würden. Wird nicht ans Backend ausgewertet.
   */
  gallery_client_id?: number;
  /** Soll das Module ein Pflichtfeld sein ? */
  required: boolean;
}

export interface IChecklistNumberModule extends IChecklistModule {
  min: number;
  max: number;
}

export function instanceOfIChecklistModule(
  object: any
): object is IChecklistModule {
  return 'dep' in object && !('modules' in object) && !('groups' in object);
}
